<template>
    <div class='borderRadiusPicker'>
        <div class='radius' :class='{"active" : boxStyleType === 0}' @click='updateBoxStyleType(0)'>
            <div class='radius-icon'></div>
        </div>
        <div class='straight' :class='{"active" : boxStyleType === 1}' @click='updateBoxStyleType(1)'>
            <div class='straight-icon'></div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        boxStyleType:{
            type: Number,
            default: null
        }
    },
    data() {
        return {
        }
    },
    methods:{
        updateBoxStyleType(e){
            this.$emit('updateBoxStyleType',e)
        }
    }
};
</script>

<style lang='scss' scoped>
.borderRadiusPicker{
    width: 94px;
    height: 35px;
    margin: 10px 0;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    overflow: hidden;
    display: flex;
    .radius{
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .radius-icon{
            width: 12px;
            height: 12px;
            border: 2px solid #000;
            border-top-left-radius: 5px;
        }
    }
    .straight{
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .straight-icon{
            width: 12px;
            height: 12px;
            border: 2px solid #000;
        }
    }
    .active{
        background-color: #409eff;
        div{
            border: 2px solid #fff !important;
        }
    }
}
</style>